import { render, staticRenderFns } from "./schoolClass.vue?vue&type=template&id=778ff6d6&scoped=true&"
import script from "./schoolClass.vue?vue&type=script&lang=js&"
export * from "./schoolClass.vue?vue&type=script&lang=js&"
import style0 from "./schoolClass.vue?vue&type=style&index=0&id=778ff6d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ff6d6",
  null
  
)

export default component.exports